import { render, staticRenderFns } from "./ProductsRecord.vue?vue&type=template&id=844f1ff8&scoped=true&"
import script from "./ProductsRecord.vue?vue&type=script&lang=js&"
export * from "./ProductsRecord.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRecord.vue?vue&type=style&index=0&id=844f1ff8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844f1ff8",
  null
  
)

export default component.exports